module.exports = __webpack_public_path__ + "img/placeholder2.fbe83da7.jpg";